import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ErrorInfo } from '@shared/error-page/error-page.component';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ErrorPageComponent } from '../../../shared/error-page/error-page.component';
import { getFatalErrors } from '../store/selectors';

@Component({
  selector: 'app-fatal-errors',
  template: '<app-error-page [error]="error" />',
  imports: [ErrorPageComponent],
})
export class FatalErrorsComponent implements OnInit {
  private _store = inject(Store);

  private _destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  error: ErrorInfo;

  ngOnInit() {
    this._store
      .select(getFatalErrors)
      .pipe(
        takeUntil(this._destroy$),
        tap((fatalErrors) => {
          this.error = {
            code: '500',
            message: 'Fatal error(s) occured.',
            details: fatalErrors.map((x) => x.payload.message).join('<br>'),
          };
        }),
      )
      .subscribe(); // TODO-MP: przerób to na async pipe :)
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }
}
